module.exports = __webpack_public_path__ + "img/no_data.58c1fd51.svg";